import React, { useCallback, useEffect, useRef, useState } from 'react';
import Icon from '../../stateless/Icon';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Button from '@mui/material/Button';

import './index.scss';

const FileUpload = ({
  onChange,
  reset,
  multiple = false,
  slug,
  name,
}) => {
  const ref = useRef();

  const [res, setRes] = useState(reset);

  const UPLOAD_ALLOWED_TYPES_PRICE = ['.pdf', '.xls', '.xlsx', '.ppt', '.pptx'];
  const UPLOAD_ALLOWED_TYPES = ['.pdf', '.ppt', '.pptx'];
  const MAX_UPLOAD_SIZE = 10 * 1024 * 1024;
  const MAX_UPLOAD_SIZE_PRICE = 2 * 1024 * 1024;

  const handleChange = useCallback(event => {
    const { files = [] } = event.target;
    if (files[0]) {
      const val = slug === 'priceSheet' ? MAX_UPLOAD_SIZE_PRICE : MAX_UPLOAD_SIZE;

      if (files[0].size > val) {
        toast(`Upload failed. File size should not exceed ${slug === 'priceSheet' ? 2 : 10}MB.`);
        ref.current.value = '';
        ref.current.files = null;
        setRes(true);
        return;
      }

      setRes(false);
    }
    const filtered = files ? Array.from(files).filter(item => item.size <= (slug === 'priceSheet' ? MAX_UPLOAD_SIZE_PRICE : MAX_UPLOAD_SIZE)) : [];

    filtered.length && onChange(filtered[0]);
  }, [onChange, ref]);

  useEffect(() => {
    reset && (ref.current.value = '');
  }, [reset, ref])

  return (
    <>
      <label className={ref.current?.value ? 'has-value' : ''}>
        <input ref={ref} type="file"
               draggable={false}
               accept={slug !== 'priceSheet' ? UPLOAD_ALLOWED_TYPES : UPLOAD_ALLOWED_TYPES_PRICE}
               multiple={multiple} onChange={handleChange} />
        <span className="field-name">{ref.current?.value ? ref.current.files[0]?.name : name}</span>
        <Button component="span">
          <Icon icon="upload-icon"/>Upload
        </Button>
      </label>
      <ToastContainer />
    </>
  );
};

export default FileUpload;
